
<script>
import { Bar as BarChartGenerator } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  BarController,
  LineElement,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  BarController,
  LineElement,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  ChartDataLabels,
);

export default {
    name: "chartEcoData",
    extends: BarChartGenerator,
    props: ['chartData', 'width', 'height'],
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        labels: {
                            color: 'white'
                        },
                    },
                    datalabels: {
                        color: 'white',
                        display: false,
                    },
                },
                scales: {
                    x: {
                        ticks: {
                            color: 'white',
                        },
                        display: true,
                        title: {
                            display: true,
                            text: trans.get("common.eco.chart.years"),
                            color: 'white',
                            font: {
                                size: 16,
                                lineHeight: 1.2,
                            },
                            padding: {top: 10, left: 0, right: 0, bottom: 0},
                        },
                    },
                    y: {
                        ticks: {
                            color: 'white',
                        },
                        display: true,
                        title: {
                            display: true,
                            text: trans.get("common.eco.chart.values"),
                            color: 'white',
                            font: {
                                size: 16,
                                lineHeight: 1.2,
                            },
                            padding: {top: 10, left: 0, right: 0, bottom: 0},
                        },
                    },
                },
            },
        };
    },
    computed: {
        myChartData() {
            return this.chartData;
        }
    },
    mounted() {        
        // valorisation des données
        this.$el.parentElement.firstChild.style="margin: auto";
        this.renderBarLineChart();
    },
    methods: {
        renderBarLineChart() {
            this.renderChart(this.myChartData, this.options);
        },
    },
    watch: {
        chartData() {
            this.renderBarLineChart();
        }
    }
};
</script>
